/* eslint-disable react/state-in-constructor */
import decodeId from 'core/libs/helpers/decodeId';
import LoadingIndicator from 'modules/common/LoadingIndicator';
import NewDesignButton from 'modules/common/NewDesignButton';
import PropTypes from 'prop-types';
import React, {Component, lazy, Suspense} from 'react';
import {injectIntl} from 'react-intl';
import QuizChoice from './QuizChoice';

const QuizFillInTheBlank = lazy(() => import('./QuizFillInTheBlank'));

class QuizTask extends Component {
  state = {
    result: undefined,
  };

  componentDidMount() {
    document.addEventListener('keyup', this.handleShortcuts);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.position !== nextProps.position) {
      this.setState({
        result: undefined,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleShortcuts);
  }

  handleShortcuts = ({keyCode}) => {
    if (keyCode === 13 && typeof this.state.result !== 'undefined') {
      this.next();
    }
  };

  checkAnswer = (answer) => {
    this.props.checkResult({
      callback: this.updateResult,
      id: decodeId(this.props.id),
      answer,
      quizAttempt: this.state.quizAttempt,
    });
  };

  updateResult = (response) => {
    this.setState({
      result: !!response.is_valid_answer,
      quizAttempt: response.quiz_attempt.id,
      quizTotalResult: response.quiz_attempt,
    });
  };

  next = () => {
    this.props.next(this.state.quizTotalResult);
  };

  render() {
    const {
      last,
      question,
      quizchoice,
      quizfillintheblank,
      quiztrueorfalse,
      isNanoDegree,
      intl: {formatMessage},
    } = this.props;
    const {result} = this.state;
    return (
      <div>
        {!quizfillintheblank ? (
          <div className="w-60-ns w-80-m w-90 center">
            <QuizChoice
              checkAnswer={this.checkAnswer}
              question={question}
              choices={quizchoice && quizchoice.choiceSet.edges}
              validAnswer={
                quizchoice
                  ? quizchoice.validAnswer
                  : quiztrueorfalse.validAnswer
              }
              result={this.state.result}
              type={quizchoice ? 'quizchoice' : 'quiztrueorfalse'}
              isNanoDegree={isNanoDegree}
            />
          </div>
        ) : (
          <Suspense fallback={<LoadingIndicator />}>
            <QuizFillInTheBlank
              checkAnswer={this.checkAnswer}
              question={question}
              title={quizfillintheblank.title}
              result={this.state.result}
            />
          </Suspense>
        )}
        <div className="tc pt3-ns pv4">
          <NewDesignButton
            active={result !== undefined}
            className={`ph3 pv-custom-1 ${
              result === undefined
                ? 'bg-moon-gray'
                : 'pointer bg-blue bg-animate hover-bg-dark-blue'
            }`}
            onClick={this.next}
            cy={result === undefined ? 'submit-inactive' : 'submit-active'}
          >
            {last
              ? `${formatMessage({id: 'finish_quiz'})}`
              : `${formatMessage({id: 'next_question'})}`}
          </NewDesignButton>
        </div>
      </div>
    );
  }
}

QuizTask.propTypes = {
  id: PropTypes.string.isRequired,
  position: PropTypes.number.isRequired,
  question: PropTypes.string.isRequired,
  quizfillintheblank: PropTypes.object,
  quizchoice: PropTypes.object,
  quiztrueorfalse: PropTypes.object,
  checkResult: PropTypes.func.isRequired,
  next: PropTypes.func.isRequired,
  last: PropTypes.bool.isRequired,
  isNanoDegree: PropTypes.bool.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(QuizTask);
